import { handleResponse } from './fetchPrices'
import mapValuesToRequestPriceForm2 from './mappers/mapValuesToRequestPriceForm2'

export default function(api: GlobalFetch) {
  return async function(values, roomId, type, objectId, calendarId, config) {
    const requestBody = mapValuesToRequestPriceForm2(
      values,
      roomId,
      type,
      objectId,
      calendarId,
      config,
    )
    const response = await api.fetch(
      `/api/v2/pricemulti/index/id_object/${objectId}/id_calendar/${calendarId}`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )

    if (response.ok) {
      return await handleResponse(response)
    } else {
      throw new Error(response.status.toString())
    }
  }
}
